<label class="label" [for]="label() + '_' + uuid">{{ label() }}</label>
@if (type() === 'textarea') {
  <textarea
    #input
    class="input"
    [id]="label() + '_' + uuid"
    [name]="label() + '_' + uuid"
    [placeholder]="placeholder()"
    [readOnly]="readOnly()"
    [(value)]="value"
    (change)="updateValue($event)"></textarea>
} @else {
  <div
    class="input-wrapper"
    [attr.data-readOnly]="readOnly()"
    [attr.data-validated]="validation()"
    [attr.data-validation]="validation() !== undefined">
    <input
      #input
      class="input"
      [id]="label() + '_' + uuid"
      [name]="label() + '_' + uuid"
      [placeholder]="placeholder()"
      [readOnly]="readOnly()"
      [type]="type()"
      [(value)]="value"
      (change)="updateValue($event)"
      (keypress)="onKeypress($event)" />
    @if (validation() !== undefined) {
      <i
        aria-hidden="true"
        [ngClass]="{
          'input-icon': true,
          'icon-check': validation(),
          'icon-close': !validation(),
        }"></i>
    }
  </div>
}
